// extracted by mini-css-extract-plugin
export default {"root":"GranosBox_root__-hmsf","container":"GranosBox_container__2R-lI","frozen":"GranosBox_frozen__8qAfy"};